"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataMapUpdateReset = exports.dataMapUpdate = exports.dataMapSuccess = exports.dataMapReset = exports.dataMapInfo = exports.dataMapFieldUser = exports.dataMapFieldReset = exports.dataMapFieldRecord = exports.dataMapFieldFundPerformance = exports.dataMapFieldFundImpact = exports.dataMapFieldFundDonors = exports.dataMapFieldFund = exports.dataMapField = exports.dataMapError = void 0;
var _dataMap = require("./dataMap.constant");
// @flow

// common success
var dataMapSuccess = function dataMapSuccess(actionType, data) {
  return {
    type: _dataMap.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.dataMapSuccess = dataMapSuccess;
var dataMapError = function dataMapError(actionType, error) {
  return {
    type: _dataMap.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * dataMap reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.dataMapError = dataMapError;
var dataMapReset = function dataMapReset(data) {
  return {
    type: _dataMap.actionTypes.RESET,
    payload: data
  };
};

/**
 * dataMap reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.dataMapReset = dataMapReset;
var dataMapUpdateReset = function dataMapUpdateReset(data) {
  return {
    type: _dataMap.actionTypes.RESET_UPDATE,
    payload: data
  };
};

/**
 * dataMap reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.dataMapUpdateReset = dataMapUpdateReset;
var dataMapFieldReset = function dataMapFieldReset(data) {
  return {
    type: _dataMap.actionTypes.RESET_FIELD,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.dataMapFieldReset = dataMapFieldReset;
var dataMapUpdate = function dataMapUpdate(data) {
  return {
    type: _dataMap.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * info
 * @param payload
 * @returns api response
 * @description this function used to get info.
 */
exports.dataMapUpdate = dataMapUpdate;
var dataMapInfo = function dataMapInfo(data) {
  return {
    type: _dataMap.actionTypes.INFO,
    payload: data
  };
};

/**
 * field
 * @param payload
 * @returns api response
 * @description this function used to get field.
 */
exports.dataMapInfo = dataMapInfo;
var dataMapField = function dataMapField(data) {
  return {
    type: _dataMap.actionTypes.FIELD,
    payload: data
  };
};

/**
 * field
 * @param payload
 * @returns api response
 * @description this function used to get field.
 */
exports.dataMapField = dataMapField;
var dataMapFieldUser = function dataMapFieldUser(data) {
  return {
    type: _dataMap.actionTypes.FIELD_USER,
    payload: data
  };
};

/**
 * field
 * @param payload
 * @returns api response
 * @description this function used to get field.
 */
exports.dataMapFieldUser = dataMapFieldUser;
var dataMapFieldRecord = function dataMapFieldRecord(data) {
  return {
    type: _dataMap.actionTypes.FIELD_RECORD,
    payload: data
  };
};

/**
 * field
 * @param payload
 * @returns api response
 * @description this function used to get field.
 */
exports.dataMapFieldRecord = dataMapFieldRecord;
var dataMapFieldFund = function dataMapFieldFund(data) {
  return {
    type: _dataMap.actionTypes.FIELD_FUND,
    payload: data
  };
};

/**
 * field
 * @param payload
 * @returns api response
 * @description this function used to get field.
 */
exports.dataMapFieldFund = dataMapFieldFund;
var dataMapFieldFundPerformance = function dataMapFieldFundPerformance(data) {
  return {
    type: _dataMap.actionTypes.FIELD_PERFORMANCE,
    payload: data
  };
};

/**
 * field
 * @param payload
 * @returns api response
 * @description this function used to get field.
 */
exports.dataMapFieldFundPerformance = dataMapFieldFundPerformance;
var dataMapFieldFundDonors = function dataMapFieldFundDonors(data) {
  return {
    type: _dataMap.actionTypes.FIELD_DONOR,
    payload: data
  };
};

/**
 * field
 * @param payload
 * @returns api response
 * @description this function used to get field.
 */
exports.dataMapFieldFundDonors = dataMapFieldFundDonors;
var dataMapFieldFundImpact = function dataMapFieldFundImpact(data) {
  return {
    type: _dataMap.actionTypes.FIELD_IMPACT,
    payload: data
  };
};
exports.dataMapFieldFundImpact = dataMapFieldFundImpact;